<template>
  <div class="flex">
    <div class="left">
      <img style="vertical-align: middle;margin: -25px 23px 0 16px;" src="../assets/index/xinxifabu.png">
      <div id="box">
        <ul id="con1" ref="con1" :class="{anim:animate==true}">
          <li v-for='(item,index) in data' :key="item.id" @click="jump(`xinxiDetail?id=${item.id}`)">{{item.title}}</li>
        </ul>
      </div>
    </div>
    <div class="right" @click="$router.push('/xinxi')">
      <span>更多</span>
      <i class="el-icon-arrow-right"></i>
    </div>
  </div>
</template>

<script>
  import {
    jump
  } from '../../static/function.js'
  export default {
    data() {
      return {
        animate: false,
        items: [{
            name: '1'
          },
          {
            name: '2'
          }
        ],
        data: [],
        timer: null
      }
    },
    created() {
      this.$http.index().then(res => {
        for (let i = 0; i < res.data.news_list.length; i++) {
          res.data.news_list[i].image = this.$imgUrl + res.data.news_list[i].thumb + ''
        }
        this.data = res.data.news_list
      })
      setInterval(this.scroll, 3000)
    },
    methods: {
      mouseOver() {
        console.log('鼠标悬停')
        clearInterval(this.timer)
      },
      scroll() {
        this.animate = true; // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true
        this.timer = setTimeout(() => { //  这里直接使用了es6的箭头函数，省去了处理this指向偏移问题，代码也比之前简化了很多
          this.data.push(this.data[0]); // 将数组的第一个元素添加到数组的
          this.data.shift(); //删除数组的第一个元素
          this.animate = false; // margin-top 为0 的时候取消过渡动画，实现无缝滚动
        }, 500)
      }
    }
  }
</script>

<style scoped>
  .left {
    justify-content: start;
  }

  img {
    vertical-align: super;
  }

  #box {
    /* width: 300px; */
    height: 32px;
    overflow: hidden;
    padding-left: 32px;
    display: inline-block;
    text-align: left;
  }

  .anim {
    transition: all 0.5s;
    margin-top: -30px;
  }

  #con1 li {
    list-style: none;
    line-height: 30px;
    height: 30px;
  }

  .flex {
    width: 1280px;
    height: 66px;
    background: #FFFFFF;
    margin: 15px auto;
    justify-content: space-between;
    box-shadow: 0px 1px 29px 1px rgba(0, 0, 0, 0.07);
  }
</style>



// WEBPACK FOOTER //
// src/components/xinxi.vue